module.exports = __webpack_public_path__ + "img/9791190136044.2e058a6e.jpg";